import type { IconProps } from '../types/IconProps.ts';
export const SunMoon: IconProps = {
    name: 'SunMoon',
    children: [
        `<path d="M9.05 21c3.08 0 5.33-2.26 5.94-5.22.08-.41-.28-.77-.7-.75-5.73.23-5.68-3.17-5.36-5.3.06-.4-.26-.78-.67-.72A6 6 0 0 0 3 14.98 6.04 6.04 0 0 0 9.05 21M15.97 12C15.8 10 15 8.07 12 8M12 4V2M20 12h2M18 6.5 19.5 5" />`,
    ]
};